import { useMemo } from 'react';
import Text from 'components/design-system/Text/Text';

export const useColumnTablesListadoGrupos = () => {
  const columnTables = useMemo(
    () => [
      {
        header: 'Código',
        enableGlobalFilter: true,
        accessorKey: 'codigoGrupo',
        Cell: ({ renderedCellValue }) => <Text>{renderedCellValue}</Text>,
        enableColumnActions: true,
        enableColumnFilter: true
      },
      {
        header: 'Nombre',
        enableGlobalFilter: true,
        accessorKey: 'nombreGrupo',
        Cell: ({ renderedCellValue }) => <Text>{renderedCellValue}</Text>,
        enableColumnActions: true,
        enableColumnFilter: true,
        muiTableHeadCellProps: {
          align: 'left'
        },
        muiTableBodyCellProps: {
          align: 'left'
        }
      },
      {
        header: 'Negocio Origen',
        enableGlobalFilter: false,
        accessorKey: 'nombreNegocioOrigen',
        enableColumnActions: false,
        enableColumnFilter: false,

        Cell: ({ renderedCellValue }) => <Text>{renderedCellValue}</Text>
      },
      {
        header: 'N° de negocios',
        enableGlobalFilter: false,
        accessorKey: 'cantidadNegocios',
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ renderedCellValue }) => <Text>{renderedCellValue}</Text>
      }
    ],
    []
  );

  return columnTables;
};
